/**
 * Ported from the server package.
 */

import { URModel, URModelNumbers } from '../model/ur.types';

export const getModels = (): URModel[] => {
  return Object.values(URModel);
};

/**
 * Gets the equivalent model numbers for the given model.
 * Example: URModel.UR10 => ['UR10', 'UR10e']
 * Example: URModel.UR8_LONG => ['UR7_LONG', 'UR8_LONG']
 */
export const getModelNumbers = (model: URModel): string[] => {
  // Clone array to avoid downstream mutation.
  return [...(URModelNumbers[model] ?? [])];
};

/**
 * Checks if the model number is a valid model number for the given model.
 * Example: (URModel.UR10, 'UR10e') => true
 * Example: (URModel.UR10, 'UR10x') => false
 */
export const isModelNumber = (model: URModel, modelNumber: string): boolean => {
  return getModelNumbers(model).includes(modelNumber);
};

/**
 * Gets the model for the given model number.
 * Example: 'UR10' => URModel.UR10
 * Example: 'URXX' => undefined
 */
export const getModelByNumber = (modelNumber: string): URModel | undefined => {
  return getModels().find((model) => isModelNumber(model, modelNumber));
};
